import React, { useState } from 'react'
import { Paper } from '@mui/material';
import { Button } from '@mui/material/Button';
import ViewResume from '../table/viewResume';



function HiringCv() {
    return (
        <div className="row">
            <Paper elevation={3}>
                <div className='p-3'>
                    <div>
                        <h4> Hiring CV's</h4>
                    </div>
                    <div className="col-12">
                        <ViewResume />
                    </div>
                </div>
            </Paper>
        </div>
    )
}

export default HiringCv;